import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const AddSurvey = createAsyncThunk(
  "Surveys/AddSurvey",
  async (parameters, { rejectWithValue }) => {
    try {
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/Surveys/AddSurvey",
        parameters
      );

      const data = response.data; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const Survey = createSlice({
  name: "Survey",
  initialState: {
    //------------- AddSurvey ---------------------
    AddSurvey: [],
    loadingAddSurvey: false,
    errorAddSurvey: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(AddSurvey.pending, (state, action) => {
        console.log(action.payload, "action.payload");

        state.loadingAddSurvey= true;
        state.AddSurvey= action.payload;
        state.errorAddSurvey= null;
      })
      .addCase(AddSurvey.fulfilled, (state, action) => {
        state.loadingAddSurvey = false;
        state.AddSurvey = action.payload;
      })
      .addCase(AddSurvey.rejected, (state, action) => {
        state.loadingAddSurvey = false;
        state.AddSurvey = action.payload;
      });
  },
});

export default Survey.reducer;
